import { formatBRL } from '../utils/currency';

/**
 * Resumo de variações/adicionais dentro do formulário do produto: mostra as
 * opções como o cliente vai vê-las (nome + preço, na ordem de exibição) e
 * delega a edição a um submodal. Antes era a lista de edição completa embutida,
 * que ocupava o dobro do espaço e não deixava claro o que o cliente veria.
 */
function ItemsSummary({ title, items = [], emptyLabel, manageLabel, onManage, disabledHint, flagField, flagOffLabel }) {
  const ordered = [...items].sort(
    (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || Number(a.price) - Number(b.price),
  );

  return (
    <div className="items-summary">
      <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
        <div className="d-flex align-items-center gap-2">
          <span className="items-summary-title">{title}</span>
          {!!ordered.length && <span className="items-summary-count">{ordered.length}</span>}
        </div>
        {onManage ? (
          <button type="button" className="action-btn action-btn-filled" onClick={onManage}>
            {manageLabel}
          </button>
        ) : (
          <span style={{ fontSize: 11.5, color: '#bbb' }}>{disabledHint}</span>
        )}
      </div>

      {ordered.length === 0 ? (
        <p className="items-summary-empty">{emptyLabel}</p>
      ) : (
        <div className="items-summary-chips">
          {ordered.map((item) => (
            <span
              key={item.id}
              className={`items-chip${item.isAvailable ? '' : ' off'}`}
              title={item.isAvailable ? undefined : 'Indisponível'}
            >
              {item.imageUrl && <img src={item.imageUrl} alt="" className="items-chip-thumb" />}
              <span className="items-chip-name">{item.name}</span>
              {/* Exceção à regra da categoria — aparece só quando o item nega o
                  que a categoria permite, para o resumo mostrar o que foge do
                  padrão sem precisar abrir o submodal. */}
              {flagField && item[flagField] === false && (
                <span className="items-chip-flag">{flagOffLabel}</span>
              )}
              <span className="items-chip-price">{item.isPaid === false ? 'Grátis' : formatBRL(Number(item.price))}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default ItemsSummary;
